/** @format */

import { Component, OnInit, Input, Output, EventEmitter, ViewChild, TemplateRef, OnChanges } from '@angular/core';
import { NgbModal, NgbModalRef, NgbTypeaheadSelectItemEvent } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ProblemContact, Problem, PhoneType } from 'src/app/models/problem';
import { ContactType, MenuItem } from 'src/app/state-management';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { provideNgxMask } from 'ngx-mask';

@Component({
    selector: 'app-contacts',
    templateUrl: './contacts.component.html',
    styleUrls: ['./contacts.component.css'],
    providers: [provideNgxMask()],
    standalone: false
})
export class ContactsComponent implements OnInit {
  @Input() contacts: ProblemContact[];
  @Input() contactTypes: ContactType[];
  @Input() problem: Problem;
  @Input() phoneTypes: PhoneType[];
	@Input() isCityworksRequest: boolean;
  @Output() contactEditEmitter = new EventEmitter<number>();
  @Output() contactDeleteEmitter = new EventEmitter<ProblemContact>();
  @Output() contactAddEmitter = new EventEmitter<null>();
  @Output() phoneDeleteEmitter = new EventEmitter<number>();

	constructor(private modalService: NgbModal) {}

	ngOnInit() {}

  editContact(id: number) {
    this.contactEditEmitter.emit(id);
  }

  deleteContact(contact: ProblemContact) {
    const deleteConfirm = confirm('Are you sure you want to delete this contact?');
    if (deleteConfirm === true) {
      this.contactDeleteEmitter.emit(contact);
    }
  }

  addContact() {
    this.contactAddEmitter.emit();
  }

  getPhoneType(id: number) {
    let phoneType = '';
    if (this.phoneTypes.length > 0) {
			phoneType = this.phoneTypes.find((p) => p.phoneType_Id === id).phoneType_Name;
    }
    return phoneType;
  }

  isNullOrEmpty(obj: any) {
    return obj === null || obj.length === 0;
  }
}
